"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var define_reactive_1 = __importDefault(require("../common/define-reactive"));
var util_1 = require("../common/util");
var merge_1 = __importDefault(require("lodash/merge"));
var parser_1 = require("../parser");
var BasePage = /** @class */ (function () {
    function BasePage(options) {
        this.ratio = 1;
        this.$options = this.optionDefineReactive(merge_1.default({}, parser_1.genPage(options), this.data()));
        var theme = this.$options.theme;
        if (theme && theme.width) {
            this.ratio = theme.width / this.$el.getBoundingClientRect().width;
        }
        this.export = function () {
            return options;
        };
        this.created();
    }
    /**
     * 响应式
     * @param options
     */
    BasePage.prototype.optionDefineReactive = function (options) {
        return define_reactive_1.default(options, {
            set: function (target, key, value, receiver) {
                this.render();
            }
        });
    };
    /**
     * 获取自定义数据
     */
    BasePage.prototype.data = function () {
        return {};
    };
    /**
     * 创建后调用
     */
    BasePage.prototype.created = function () { };
    /**
     * 渲染
     */
    BasePage.prototype.render = function () {
        var options = this.$options, theme = options.theme;
        if (!theme) {
            return;
        }
        this.$el.style.cssText += util_1.buildStyleWithTheme(theme).join(";");
    };
    /**
     * 挂载
     * @param el
     */
    BasePage.prototype.amount = function (el) {
        this.$el = el;
        this.render();
    };
    /**
     * 弹性布局
     */
    BasePage.prototype.layoutAdapter = function (el, options) {
        var cssText = ["position: absolute"], _a = options.position, position = _a === void 0 ? {} : _a;
        for (var key in position) {
            var value = position[key];
            if (!value && ["width", "height"].indexOf(key) > -1) {
                cssText.push(key + ": 100%");
            }
            else if (/%$/.test(value)) {
                cssText.push(key + ": " + value);
            }
            else {
                cssText.push(key + ": " + value * this.ratio + "px");
            }
        }
        el.style.cssText += cssText.join(";");
    };
    /**
     * 添加图表
     * @param el
     */
    BasePage.prototype.add = function (el) {
        this.$el.appendChild(el);
    };
    return BasePage;
}());
exports.default = BasePage;
//# sourceMappingURL=BasePage.js.map